
/**
 * Preloader scripts.
 *
 * Handles animating the preloader.
 */

/** Dependencies -------------------------------------------- */

// External

import gsap from 'gsap'
// import ScrollSmoother from 'gsap/ScrollSmoother'

// gsap.registerPlugin( ScrollSmoother )

// Design system

import { getInternalLinks } from '../helpers'

/** The beef ------------------------------------------------ */

/**
 * The completion event to fire off once the preloader is done animating.
 */
export const completionEventName = 'preloaderComplete'
export const completionEvent = new Event( completionEventName )

/**
 * Preloader mixin.
 * Provides preloader functionality to single element.
 */
export let mixin = ( { node = null, config = {} } = {} ) => {

    let state = {
        node,
        config,
        internalLinks : null,
        timeline      : null,
    };

    let module = {

        // Setup

        init() {

            state.internalLinks = getInternalLinks()

            state.timeline = gsap.timeline()
                .delay( state.config.animationDelay )
                .to( node, { opacity: 0, duration: state.config.animationInDuration } )
                .call( () => window.dispatchEvent( completionEvent ), [], `>-${state.config.completionOffset}` )

            this.setEventBindings()
        },

        setEventBindings() {
            
            Array.from( state.internalLinks ).map(
				( link ) => link.addEventListener( 'click', this.onInternalLinkClick )
			)
        },

        // Handlers

        onInternalLinkClick( event ) {

            // We want to preserve meta+click capabilities for new tabs
            // We also don't want to to anything when default has been prevented
            
            if ( ! event.metaKey && ! event.defaultPrevented ) {

                event.preventDefault()
                const toUrl = event.currentTarget.href

                gsap.to(
                    state.node,
                    {
                        opacity    : 1,
                        duration   : state.config.animationOutDuration,
                        onComplete : () => window.location.assign( toUrl )
                    }
                )
            }
        }
    };

    return module.init()
};

/**
 * Preloader module.
 * Provides an interface to apply preloader functionality to all elements matching a selector.
 */
export default {

    init( { selector, config = {} } ) {

        let selected = document.querySelectorAll( selector )

        if ( ! selected.length ) {
            window.dispatchEvent( completionEvent )
            return
        }

        const defaultConfig = {
            animationDelay       : 0.25,
            animationInDuration  : 0.4,
            animationOutDuration : 0.2,
            completionOffset     : 0.2
        }

        return Array.from( selected ).map(
            ( node, index ) => mixin( { node, config: { ...defaultConfig, ...config } } )
        )
    }
}
